export const ribbon = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        position: "absolute",
        overflow: "hidden",
        height: "200px",
        width: "150px",
        background: "transparent",
        zIndex: "1",
    },
    ribbon: {
        background: theme.customPalette.black,
        transform: "rotate3d(0,0,1,-45deg)",
        position: "absolute",
        textAlign: "center",
        top: 26,
        left: -35,
        width: 150,
    },
    text: {
        display: "inline-block",
        height: "100%",
        verticalAlign: "middle",
    },
});
